var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{ref:"ac",attrs:{"items":_vm.items,"text":_vm.text,"isAsync":_vm.isLoading,"placeholder":_vm.placeholder,"icon":_vm.icon},on:{"change":_vm.debounce,"selected":_vm.onSelected,"clear":_vm.onClear}})
}
var staticRenderFns = []

export { render, staticRenderFns }